module.exports = "/_next/static/images/d5f52eca86d32e719e4286ab85534958-app-screenshots-lg@1x.jpg";